

class Cursor{
    constructor(){
        this.main = document.getElementById('cursor');

        this._x = 0;
        this._y = 0;

        this._visible = false;

        // Cursor hover state
        let hoverElements = Array.from(document.querySelectorAll("a, .link, .btn, .btn-circled, .btn-close, .btn-menu, .btn-search, .btn-square, .btn-upload-photo, .input-file__input, .search__icon, .tooltip, .scroll-down, .dropdown"));
        
        let draggableElements = Array.from(document.querySelectorAll('.draggable-area'));  
        
        this._isDragging = false;
        this._isOverDraggableElement = false;
        
        hoverElements.forEach((element)=>{
            element.addEventListener('mouseenter', this._onMouseEnterHoverElements.bind(this));
            element.addEventListener('mouseleave', this._onMouseLeaveHoverElements.bind(this));
        });
        
        draggableElements.forEach((element)=>{
            element.addEventListener('mouseenter', this._onMouseEnterDraggableElements.bind(this));
            element.addEventListener('mousedown', this._onMouseDownDraggableElements.bind(this));
            element.addEventListener('mouseleave', this._onMouseLeaveDraggableElements.bind(this));
        });
        
                
       /*  .mouseenter(function() {
            $('#cursor .cursor__type--default').addClass('cursor__type--hover');
        })
        .mouseleave(function() {
            $('#cursor .cursor__type--default').removeClass('cursor__type--hover');
        });

        // Cursor draggable state
        $(".draggable-area")
        .mouseenter(function() {
            $('#cursor').removeClass('cursor--default');
            setTimeout(function() {
            $('#cursor').addClass('cursor--draggable');
            }, 100);
        })
        .mouseleave(function() {
            $('#cursor').removeClass('cursor--draggable');

            setTimeout(function() {
            $('#cursor').addClass('cursor--default');
            }, 100);
        }); */
               
        
        document.addEventListener('mousemove', this._onMouseMove.bind(this));
        document.addEventListener('mouseup', this._onMouseUp.bind(this));
        document.addEventListener('click', this._onClick.bind(this));
        
    }

    _onMouseMove(e){
        this._x = e.pageX;
        this._y = e.pageY;

        this.main.style.left = this._x + 'px';
        this.main.style.top = this._y + 'px';
        
        // Init cursor when mouse start to move
        if (!this._visible){
            this._visible = true;

            setTimeout(()=>{
                this.main.classList.add('cursor--show');
            }, 200);
        }
    }

    _onClick(e){
        this.main.classList.add("cursor--expand");
        
        setTimeout(() => {
            this.main.classList.remove("cursor--expand");
        }, 500);
    }

    _onMouseEnterHoverElements(e){
        this.main.querySelector('.cursor__type--default').classList.add('cursor__type--hover');
    }

    _onMouseLeaveHoverElements(e){
        this.main.querySelector('.cursor__type--default').classList.remove('cursor__type--hover');
    }

    _onMouseEnterDraggableElements(e){
        this._isOverDraggableElement = true;
        
        if(!e.currentTarget.classList.contains('draggable-area--disabled')){
            this.main.classList.remove('cursor--default');
            this.main.classList.add('cursor--draggable');
        }        
    }

    _onMouseLeaveDraggableElements(e){
        this._isOverDraggableElement = false;

        if(!this._isDragging){
            this.main.classList.remove('cursor--draggable');
            this.main.classList.add('cursor--default');
        }        
    }

    _onMouseDownDraggableElements(e){
        if(!this._isDragging){
            this._isDragging = true;
        }
    }

    _onMouseUp(e){
        if(!this._isOverDraggableElement && this._isDragging){
            this.main.classList.remove('cursor--draggable');
            this.main.classList.add('cursor--default');
        }

        this._isDragging = false;
    }



}

export default Cursor;